import { getLorryDetailsByName } from '../constants/lorryTypes.js';

function load(inputData) {
    var _a;
    return {
        company_id: inputData.company_id,
        source_text: inputData.source,
        destination_text: inputData.destination,
        expected_amount: inputData.expected_amount,
        expected_type: inputData.expected_type,
        expires_at: inputData.expiration_time,
        id: inputData.entity_id,
        lorry_type_id: (_a = getLorryDetailsByName(inputData.available_for.split(" ")[2])) === null || _a === void 0 ? void 0 : _a.id,
        lorry_type_text: inputData.available_for.split(" ")[2],
        material_type: inputData.material_type,
        payment_type: inputData.entity_payment_type,
        quantity: Number(inputData.available_for.split(" ")[0]) || undefined
    };
}
function lorry(inputData) {
    var _a;
    return {
        capacity: Number(inputData.available_for.split(" ")[0]) || undefined,
        capacity_unit: inputData.available_for.split(" ")[1],
        company_id: inputData.company_id,
        expires_at: inputData.expiration_time,
        name: inputData.available_for.split(" ")[2],
        number: inputData.lorry_number,
        type: (_a = getLorryDetailsByName(inputData.available_for.split(" ")[2])) === null || _a === void 0 ? void 0 : _a.id,
        lorry_id: inputData.entity_id
    };
}
const GetMarketDataFromBidData = { load, lorry };

export { GetMarketDataFromBidData };
//# sourceMappingURL=getMarketDataFromBidData.js.map
